'use strict';

import React, { PropTypes } from 'react';
import createStoreMixin from '../mixins/createStoreMixin';
import StampStore from '../stores/StampStore';
import UserStore from '../stores/UserStore';
import ZineStore from '../stores/ZineStore';
import ScreenSizeMixin from '../mixins/ScreenSizeMixin';
import MetaList from '../molecules/MetaList';
import UserInfo from '../organisms/UserInfo';
import ZineInfo from '../organisms/ZineInfo';
import shallowEqual from 'react/lib/shallowEqual';
import formatDate from '../utils/formatDate';
import Rotator from '../molecules/Rotator';
import PureRenderMixin from '../mixins/PureRenderMixin';
import StampStatus from '../constants/StampStatus';
import Icon from '../atoms/Icon';

var StampNavHeader = React.createClass({
  mixins: [createStoreMixin(StampStore, UserStore, ZineStore), ScreenSizeMixin, PureRenderMixin],

  propTypes: {
    stampId: PropTypes.number.isRequired,
    primaryZineSlug: PropTypes.string,
    scrolledPastNextUp: PropTypes.bool.isRequired,
    nextUpTitle: PropTypes.string.isRequired
  },

  getStateFromStores(props) {
    var stamp = StampStore.get(props.stampId),
        primaryZine,
        user;

    if (stamp) {
      user = UserStore.get(stamp.user);
    }

    if (props.primaryZineSlug) {
      primaryZine = ZineStore.get(props.primaryZineSlug);
    }

    return {
      stamp: stamp,
      primaryZine: primaryZine,
      user: user
    };
  },

  componentWillReceiveProps(nextProps) {
    if (!shallowEqual(nextProps, this.props)) {
      this.setState(this.getStateFromStores(nextProps));
    }
  },

  render() {
    if (!this.state.stamp || !this.state.user) {
      return null;
    }

    return (
      <Rotator activeIndex={this.props.scrolledPastNextUp ? 1 : 0}>
        {this.renderStampInfo()}
        {this.renderNextUpTitle()}
      </Rotator>
    );
  },

  renderNextUpTitle() {
    return (
      <div>
        {this.props.nextUpTitle}
      </div>
    );
  },

  renderStampInfo() {
    const { isMobile, stamp, primaryZine, user } = this.state;
    const published = new Date(stamp.published);
    const isUnlisted = stamp.status === StampStatus.UNLISTED;

    return (
      <MetaList context='NavBar'
                inline={!isMobile}
                separated={!isMobile}>
        {this.state.primaryZine && !isMobile &&
          <ZineInfo zine={primaryZine}
                    context='NavBar'
                    imageSize='small'
                    size='small' />
        }
        <UserInfo user={user}
                  context='NavBar'
                  imageSize='small'
                  size='xsmall'>
          <span>
            {' on '}{formatDate(published)}
            {isUnlisted &&
              <span title='This Stamp is only visible to those with the direct link to it.'>
                <Icon name='eyeCrossed'
                      mode='fill'
                      size={isMobile ? 'xsmall' : 'small'}
                      margin='left' />
              </span>
            }
          </span>
        </UserInfo>
      </MetaList>
    );
  }
});

module.exports = StampNavHeader;



/** WEBPACK FOOTER **
 ** ./molecules/StampNavHeader.jsx
 **/